import React, { memo, useState } from "react";
import {TextField , Autocomplete, createFilterOptions}  from "@mui/material";
import styled from "styled-components";

const StyledAutocomplete = styled(Autocomplete)`
  text-align: left;
  width: 100%;
  
  & .MuiAutocomplete-inputRoot {
    height: ${(props) => (props.usergroup ? '40px' : '30px')};
    padding: 2px 0px 2px 8px;
  }
  & .MuiAutocomplete-input {
    height: 0px;
    font: ${(props) => (props.usergroup ? 'normal normal 16px Open Sans' : 'normal normal 550 14px/19px Open Sans')};
    letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  align-items: center;
  text-transform: capitalize;
  }
`;


const TypeSelect = ({ 
  options, 
  control, 
  setControl, 
  disabled,
  setInputControl = () => {}, 
  onHandleFocus, 
  isFreeSolo = false,
  isLoading = false,
  options_limit,
  placeholder,
  usergroup = false
  }) => {
  const handleChange = (event ,  newValue) => {
    setControl(newValue);
  };

  const handleInputChange = (event ,  newValue) => {
    setInputControl(newValue);
  };

  const filterOptions = createFilterOptions({
    limit: options_limit
  });

  return (
      <StyledAutocomplete      
        value={control || ""}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onFocus={onHandleFocus}
        id="type-select"
        //style={{ marginTop: "0px",border: "1px solid black", }}
        options={options}
        {...(options_limit && { filterOptions })}
        autoHighlight
        disabled={disabled}
        loading={isLoading}
        usergroup={usergroup}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            inputProps={{
              ...params.inputProps,
               
            }}
          />
        )}
      />
  );
}

export default memo(TypeSelect);